import {
  useLocation,
  useParams,
  useRouterState,
  useSearch,
} from '@tanstack/react-router';
import type { ProductionDeclarationStepKey } from '@/features/production-declaration/components/shared/production-declaration-stepper';
import { useProductionDeclaration } from '@/features/production-declaration/hooks/use-production-declaration';

type RouteStaticData = {
  stepKey?: ProductionDeclarationStepKey;
};

export function useProductionDeclarationLayout() {
  const { id } = useParams({ strict: false });
  const { token } = useSearch({ strict: false });
  const location = useLocation();
  const { matches } = useRouterState({
    select: (state) => ({
      matches: state.matches,
    }),
  });
  const productionDeclarationId = `${id}`;
  const basePath = `/production-declarations/${productionDeclarationId}`;
  const { queryKey, loadErrorMessage } = useProductionDeclaration(
    productionDeclarationId,
    token,
  );

  const activeMatch = matches.at(-1);
  const activeStaticData = (activeMatch?.staticData ?? {}) as RouteStaticData;

  return {
    activeStepKey: activeStaticData.stepKey,
    isBaseRoute: location.pathname === basePath,
    loadErrorMessage,
    productionDeclarationId,
    queryKey,
    token,
  };
}
